var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 2V0H24V2H26V3H24V5H23V3H21V2H23ZM14.5 5.5H12V4.25H18.5V5.5H16V6.54484C21.6065 7.05007 26 11.762 26 17.5C26 23.5751 21.0751 28.5 15 28.5C8.92487 28.5 4 23.5751 4 17.5C4 11.5924 8.65693 6.77256 14.5 6.51116V5.5ZM15 27C9.7533 27 5.5 22.7467 5.5 17.5C5.5 12.2533 9.7533 8 15 8C20.2467 8 24.5 12.2533 24.5 17.5C24.5 22.7467 20.2467 27 15 27ZM20.0772 18.7506L15.5315 18.7505L15.5316 12.5005L14.0316 12.5005L14.0315 19.5005C14.0315 19.9147 14.3673 20.2505 14.7815 20.2505L20.0771 20.2506L20.0772 18.7506ZM29 9H27V10H29V12H30V10H32V9H30V7H29V9Z",
    fill: "#585D66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatTimeIcon);
export default __webpack_public_path__ + "static/media/chat-time-icon.e470b0c95b7ea7e2d13b1103f916d335.svg";
export { ForwardRef as ReactComponent };